import React, { useEffect } from 'react'
import ScrollTop from './scrollTop';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './PublicPanel/HomePage/HomePage';
import ContactUsMainPage from './PublicPanel/ContactUs/ContactUsMainPage';
import AboutUsMain from './PublicPanel/AboutUs/AboutUsMain';
import Navbar from './PublicPanel/HomePage/Navbar';
import EventMainPage from './PublicPanel/Events/EventMainPage';
import OurWorkMainPage from './PublicPanel/OurWork/OurWorkMainPage.js';
import InitiativesMainDetailPage from './PublicPanel/Initiatives/InitiativesMainDetailPage.js';
import { useDispatch } from 'react-redux';
import { openVolunteerPopup } from './PublicPanel/features/volunteerPopupSlice.js';
import VolunteerFormPopup from './PublicPanel/volunteerForm/VolunteerFormPopup.js';
import AdminUserLogin from './AdminPanel/Pages/AdminUserLogin.js';
import HomepageBanner from './AdminPanel/Pages/HomepageBanner.js';
import PrivateRoute from './AdminPanel/Pages/PrivateRoute.js';
import AboutUsMissionAndVision from './AdminPanel/Pages/AboutUsMissionAndVision.js';
import CoreInitiativeList from './AdminPanel/Pages/CoreInitiativeList.js';
import CoreServicesList from './AdminPanel/Pages/CoreServicesList.js';
import EventsList from './AdminPanel/Pages/EventsList.js';
import HomePageBannerList from './AdminPanel/Pages/HomePageBannerList.js';
import HomePageGalleryList from './AdminPanel/Pages/HomePageGalleryList.js';
import InitiativeList from './AdminPanel/Pages/InitiativeList.js';
import TeamMemberList from './AdminPanel/Pages/TeamMemberList.js';
import WordsThatInspireList from './AdminPanel/Pages/WordsThatInspireList.js';
import MediaFiles from './AdminPanel/Pages/MediaFiles.js';
import ImagesAndVideos from './AdminPanel/Pages/ImagesAndVideos.js';
import FaqList from './AdminPanel/Pages/FaqList.js';
import VolunteerList from './AdminPanel/Pages/VolunteerList.js';
import ContactusList from './AdminPanel/Pages/ContactusList.js';
import NewsLetter from './AdminPanel/Pages/NewsLetter.js';
import DonationMainPage from './PublicPanel/Donation/DonationMainPage.js';
export default function App() {
  const dispatch = useDispatch();
  const location = useLocation()

  // check admin route
  const isAdminRoute = location.pathname.startsWith('/admin')

  // useEffect(() => {
  //   const shown = sessionStorage.getItem("volunteerPopupShown");
  //   console.log("shown", shown)
  //   if (!shown) {

  //     const timer = setTimeout(() => {
  //       dispatch(openVolunteerPopup());
  //       sessionStorage.setItem("volunteerPopupShown", "true");
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [dispatch]);
  const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\s+/g, "-");
};
  return (
    <div>
      <ScrollTop />

      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/connect" element={<ContactUsMainPage />} />
        <Route path="/about-us" element={<AboutUsMain />} />
        <Route path="/engagement/:title" element={<EventMainPage />} />
        <Route path="/contribute" element={<DonationMainPage />} />
        <Route path="/initiative/:title" element={<OurWorkMainPage />} />
        {/* <Route path="/initiative/:title" element={<InitiativesMainDetailPage />} /> */}
        <Route path="/admin/login" element={<AdminUserLogin />} />


        <Route path="/admin/home/banner" element={
          <PrivateRoute>
            <HomepageBanner />

          </PrivateRoute>

        } />
        <Route path="/admin/about-us-mission-and-vision" element={
          <PrivateRoute>
            <AboutUsMissionAndVision />

          </PrivateRoute>

        } />
        <Route path="/admin/core_initiative_list" element={
          <PrivateRoute>
            <CoreInitiativeList />

          </PrivateRoute>

        } />
        <Route path="/admin/core-services" element={
          <PrivateRoute>
            <CoreServicesList />

          </PrivateRoute>

        } />
        <Route path="/admin/events" element={
          <PrivateRoute>
            <EventsList />

          </PrivateRoute>

        } />
        <Route path="/admin/home-page-banners" element={
          <PrivateRoute>
            <HomePageBannerList />

          </PrivateRoute>

        } />

        <Route path="/admin/home-page-galleries" element={
          <PrivateRoute>
            <HomePageGalleryList />

          </PrivateRoute>

        } />

        <Route path="/admin/initiatives" element={
          <PrivateRoute>
            <InitiativeList />

          </PrivateRoute>

        } />
        <Route path="/admin/team-members" element={
          <PrivateRoute>
            <TeamMemberList />

          </PrivateRoute>

        } />

        <Route path="/admin/words-that-inspire" element={
          <PrivateRoute>
            <WordsThatInspireList />

          </PrivateRoute>

        } />

        <Route path="/admin/media-file" element={
          <PrivateRoute>
            <ImagesAndVideos />

          </PrivateRoute>

        } />

        <Route path="/admin/faq-list" element={
          <PrivateRoute>
            <FaqList />

          </PrivateRoute>

        } />

        <Route path="/admin/volunteer-list" element={
          <PrivateRoute>
            <VolunteerList />

          </PrivateRoute>

        } />

        <Route path="/admin/contact-us" element={
          <PrivateRoute>
            <ContactusList />

          </PrivateRoute>

        } />

        <Route path="/admin/newsletter" element={
          <PrivateRoute>
            <NewsLetter />

          </PrivateRoute>

        } />

      </Routes>

    </div>
  )
}